import { actionTypes } from '../actions';
import { debugLogToConsole } from '../utils';

const initialState = {
  searchingFacilities: false,
  facilitySearchResults: [],
  searchingSurgeons: false,
  surgeonsSearchResults: [],
  searchingAnesthesiologists: false,
  anesthesiologistsSearchResults: [],
  searchingAnesthesiaProcedures: false,
  anesthesiaProceduresSearchResults: [],
  searchingCrnas: false,
  crnasSearchResults: [],
  searchingCptCodes: false,
  cptCodesSearchResults: [],
  searchingIcd10: false,
  icd10CodesSearchResults: []
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.initiateFacilitySearch:
      return {
        ...state,
        searchingFacilities: true
      };
    case actionTypes.searchFacilities:
      return {
        ...state,
        facilitySearchResults: action.payload.facilities,
        searchingFacilities: false
      };
    case actionTypes.resetFacilitySearch:
      return {
        ...state,
        facilitySearchResults: []
      };
    case actionTypes.initiateSurgeonSearch:
      return {
        ...state,
        searchingSurgeons: true
      };
    case actionTypes.searchSurgeons:
      return {
        ...state,
        surgeonsSearchResults: action.payload.users,
        searchingSurgeons: false
      };
    case actionTypes.resetSurgeonSearch:
      return {
        ...state,
        surgeonsSearchResults: []
      };
    case actionTypes.initiateAnesthesiologistSearch:
      return {
        ...state,
        searchingAnesthesiologists: true
      };
    case actionTypes.searchAnesthesiologists:
      return {
        ...state,
        anesthesiologistsSearchResults: action.payload.users,
        searchingAnesthesiologists: false
      };
    case actionTypes.resetAnesthesiologistSearch:
      return {
        ...state,
        anesthesiologistsSearchResults: []
      };
    case actionTypes.initiateCrnaSearch:
      return {
        ...state,
        searchingCrnas: true
      };
    case actionTypes.searchCrnas:
      return {
        ...state,
        crnasSearchResults: action.payload.users,
        searchingCrnas: false
      };
    case actionTypes.resetCrnaSearch:
      return {
        ...state,
        crnasSearchResults: []
      };
    case actionTypes.initiateCptSearch:
      return {
        ...state,
        searchingCptCodes: true
      };
    case actionTypes.searchCpt:
      debugLogToConsole('=== REDUCER ===');
      debugLogToConsole(action.payload.cptCodes);
      return {
        ...state,
        cptCodesSearchResults: action.payload.cptCodes,
        searchingCptCodes: false
      };
    case actionTypes.resetCptSearch:
      return {
        ...state,
        cptCodesSearchResults: []
      };
    case actionTypes.initiateAnesthesiaProcedureSearch:
      return {
        ...state,
        searchingAnesthesiaProcedures: true
      };
    case actionTypes.searchAnesthesiaProcedures:
      return {
        ...state,
        anesthesiaProceduresSearchResults: action.payload.anesthesiaProcedures,
        searchingAnesthesiaProcedures: false
      };
    case actionTypes.initiateIcd10Search:
      return {
        ...state,
        searchingIcd10: true
      };
    case actionTypes.searchIcd10:
      return {
        ...state,
        icd10CodesSearchResults: action.payload.icd10Codes,
        searchingIcd10: false
      };
    case actionTypes.resetIcd10Search:
      return {
        ...state,
        icd10CodesSearchResults: []
      };
    default:
      return { ...state };
  }
}
